export default __webpack_public_path__ + "static/media/tapeMeasure.98a8e72f.png";